import {Grid, SvgIcon} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import {OWNER_TYPE} from "../../utils/constants";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";


const SingerFields = ({singersId, percent, vat, type, userList, onDelete, onChange})=>{
    let singers = [];
    for (const userListKey in userList) {
        let user = userList[userListKey];
        if(user["role"] === "ARTIST"){
            singers.push({label: user.name, id: user.id});
        }
    }

    console.log(singersId);

    return (
        <Grid
            container
            rowSpacing={2}
            columnSpacing={1}
            justifyContent="flex-end"
            sx={{marginBottom: 4}}
        >
            <Grid
                item
                xs={12}
            >
                <Autocomplete
                    disablePortal
                    // freeSolo
                    noOptionsText={"Нет доступных лицензиаров в списке"}
                    id="combo-box-demo"
                    options={singers}
                    onChange={(event, newValue) => {
                        // setValue(newValue);
                        console.log(event, newValue);
                        if(newValue){
                            onChange({
                                target: {
                                    value: newValue.id,
                                    name: "singersId"
                                }
                            });
                        }
                    }}
                    renderInput={(params, ref) => <TextField
                        {...params}
                        color="secondary"
                        name={"singersId"}
                        ref={ref}
                        inputProps={{
                            ...params.inputProps, // HERE
                            maxLength: 255
                        }}
                    />}
                    getOptionLabel={(option) => {
                        // console.log(option);
                        // console.log(userList);
                        for (const userListKey in userList) {
                            if(userList[userListKey]['id'] === option.id){
                                return userList[userListKey]['name'];
                            }
                        }
                        return userList[option] ? userList[option].name : ""
                    }}
                    value={singersId}
                    isOptionEqualToValue={(option, value)=> {
                        // console.log(option);
                        // console.log(singersId);
                        // console.log(value);
                        return singersId === value
                    }}
                />
            </Grid>
            <Grid
                item
                xs={4}
            >
                <Select
                    label={'Права'}
                    value={type}
                    name={"type"}
                    color="secondary"
                    onChange={onChange}
                    sx={{width: "100%"}}
                >
                    {OWNER_TYPE.map((item, index) => (<MenuItem value={index} key={item.value}>{item.label}</MenuItem>))}
                </Select>
            </Grid>
            <Grid
                item
                xs={2}
            >
                <TextField
                    className="login__page__item"
                    label="Процент"
                    variant="outlined"
                    color="secondary"
                    name={'percent'}
                    value={percent}
                    type="number"
                    onChange={onChange}
                />
            </Grid>
            <Grid
                item
                xs={2}
            >
                <TextField
                    className="login__page__item"
                    label="VAT"
                    variant="outlined"
                    color="secondary"
                    name={'vat'}
                    value={vat}
                    type="number"
                    onChange={onChange}
                />
            </Grid>
            <Grid
                item
                xs={1}
            >
                <SvgIcon onClick={onDelete}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ff6000">
                        <path d="M0 0h24v24H0V0z" fill="none"/>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/>
                    </svg>
                </SvgIcon>
            </Grid>
        </Grid>
    )
}

export default SingerFields;